import {Form} from 'antd';
import React from 'react';

import QuestionnaireSwitch from '../../../pages/esgManager/utils/QuestionnaireSwitch';

interface RouteFieldWithFilteredOptionsProps {
  formField: any;
  goodsFieldNameForRoutes: string;
  selectedYear: string | null;
  replaceCurrentAndPrevious: (text: string, year: string) => string;
  getFilteredRouteOptions: (
    selectedGoodsCategory: string | undefined,
    allRouteOptions: any[]
  ) => any[];
}

const RouteFieldWithFilteredOptions: React.FC<
  RouteFieldWithFilteredOptionsProps
> = ({
  formField,
  goodsFieldNameForRoutes,
  selectedYear,
  replaceCurrentAndPrevious,
  getFilteredRouteOptions
}) => {
  return (
    <Form.Item key={formField.fieldName} noStyle shouldUpdate>
      {({getFieldValue}) => {
        const selectedGoodsCategory = getFieldValue(goodsFieldNameForRoutes) as
          | string
          | undefined;
        const options = getFilteredRouteOptions(
          selectedGoodsCategory,
          formField.options || []
        );

        return (
          <QuestionnaireSwitch
            field={{
              fieldType: formField.type,
              fieldLabel: replaceCurrentAndPrevious(
                formField.fieldLabel,
                selectedYear ?? ''
              ),
              textLimit: formField.textLimit,
              options,
              heading: replaceCurrentAndPrevious(
                formField.heading,
                selectedYear ?? ''
              ),
              colSpan: formField.colSpan,
              restrictFutureDateSelection:
                formField.restrictFutureDateSelection,
              fieldName: formField.fieldName,
              units: formField.units,
              dateFormat: formField.dateFormat,
              relatedKey: formField.relatedKey,
              formula: formField.formula,
              roundTo: formField.roundTo,
              disabled: formField.disabled,
              disabledOn: formField.disabledOn,
              fileUploadAction: formField.fileUploadAction,
              fileUploadValidExtensions: formField.fileUploadValidExtensions,
              fileUploadMaxSize: formField.fileUploadMaxSize,
              fileUploadAllowMultipleFiles:
                formField.fileUploadAllowMultipleFiles,
              conditions: formField.conditions,
              requiredOn: formField.requiredOn
                ? {
                    ...formField.requiredOn,
                    fieldName: formField.requiredOn.fieldName
                  }
                : undefined
            }}
          />
        );
      }}
    </Form.Item>
  );
};

export default RouteFieldWithFilteredOptions;
